export const FormBoxMixin = {
  props: {
    options: {
      type: Array,
      required: true
    },
    disabledOptions: {
      type: Array,
      default: () => []
    },
    tooltips: {
      type: Array,
      required: false
    },
    trackBy: {
      type: String,
      default: 'key'
    },
    isHorizontal: {
      type: Boolean,
      default: false
    },
    isMultiline: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'medium',
      validator: (prop) => ['small', 'medium', 'large', 'auto'].includes(prop)
    },
    boxClasses: { Type: Array, default: () => [] }
  },
  methods: {
    getValue(option) {
      return option.value || option.name;
    },
    isSelected(option) {
      if (Array.isArray(this.computedValue)) {
        return this.computedValue.includes(option[this.trackBy]);
      }

      return this.computedValue === option[this.trackBy];
    },
    isDisabledOption(option) {
      return this.disabledOptions.includes(option[this.trackBy]);
    }
  }
};
